<div class="container-fluid-modal">

<form class="form-inline required" #cat="ngForm" (ngSubmit)="cat.form.valid && submitForm(cat.value)" novalidate>

<div class="add" *ngIf="!editData">
    <div class="ModalHeader">
        <h4 mat-dialog-title>Add City</h4>
        <div class="headerButton">
            <button type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
            </button>
            <button type="button" class="btn btn-warning"  matDialogClose (click)="close()"><i class="fa fa-times" aria-hidden="true" ></i> Cancel
            </button>
        </div>
    </div>

    <mat-dialog-content>
        <div class="card">
            <div class="card-body">
                <div class="form-group col-lg-12">

                        <div class="form-group col-lg-12">
                            <label for="Region" class="labelRequired">Region </label>
                            <select id="mySelect" data-show-content="true" class="form-control" placeholder="Region"
                                [(ngModel)]="model.region_id" name="region_id" (change)="regionChange($event)" required #region_id="ngModel" [ngClass]= "{'has-danger': cat?.submitted  && region_id?.invalid }">
                                <option>Select Region</option>
                                <option *ngFor="let data of regionsData" [value]="data?.id">
                                    {{data?.name}}
                                </option>
                            </select>
                            <div *ngIf="cat?.submitted  && region_id?.invalid">
                                    <div [hidden]="!region_id.errors.required" class="formError"> * Region Name is required
                                    </div>
                            </div>
                        </div>

                        <div class="form-group col-lg-12">
                            <label for="Country" class="labelRequired">Country </label>
                            <select id="mySelect" data-show-content="true" class="form-control" placeholder="Country"
                                [(ngModel)]="model.country_id" name="country_id" required #country_id="ngModel" [ngClass]= "{'has-danger': cat?.submitted  && country_id?.invalid }">
                                <option disabled>Select Country</option>
                                <option *ngFor="let data of countriesSelect" [value]="data?.id">
                                    {{data?.name}}
                                </option>
                            </select>
                            <div *ngIf="cat?.submitted  && country_id?.invalid">
                                    <div [hidden]="!country_id.errors.required" class="formError"> * Country Name is required </div>
                            </div>
                        </div>

                        <div class="form-group col-lg-12">
                            <label for="City" class="labelRequired">City </label>
                            <input type="text" class="form-control" placeholder="City" name="name" #name="ngModel" [(ngModel)]="user.name" required [ngClass]= "{'has-danger': cat?.submitted  && name?.invalid }">
                            <div *ngIf="cat?.submitted  && name?.invalid ">
                                <div [hidden]="!name.errors.required" class="formError"> * City Name is required </div>
                            </div>
                        </div>

                </div>


            </div>

        </div>

    </mat-dialog-content>
</div>


<div class="edit" *ngIf= "editData">
                <div class="ModalHeader">
                    <h4 mat-dialog-title>Edit City</h4>
                    <div class="headerButton">
                        <button *ngIf="editPermission" type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
                        </button>
                        <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i
                                class="fa fa-times" aria-hidden="true"></i> Cancel
                        </button>
                    </div>
                </div>

                <mat-dialog-content>
                    <div class="card">
                        <div class="card-body">
                        <div class="form-group col-lg-12">
                            <div class="form-group col-lg-12">
                                <label for="Region" class="labelRequired">Region </label>
                                <select id="mySelect" data-show-content="true" class="form-control" placeholder="Region" [ngClass]="{'has-danger':cat?.submitted && region_id?.invalid }" [(ngModel)]="model.region_id" name="region_id" (change)="regionChange($event)" #region_id="ngModel" formnovalidate>
                                    <option disabled>Select Region</option>
                                    <option *ngFor="let data of regionsData" [value]="data?.id">
                                        {{data?.name}}
                                    </option>
                                </select>
                            </div>

                            <div class="form-group col-lg-12">
                                <label for="Country" class="labelRequired">Country </label>
                                <select id="mySelect" data-show-content="true" class="form-control" placeholder="Country"
                                    [(ngModel)]="model.country_id" name="country_id" formnovalidate>
                                    <option disabled>Select Country</option>
                                    <option *ngFor="let data of countriesSelect" [value]="data?.id">
                                        {{data?.name}}
                                    </option>
                                </select>
                            </div>

                            <div class="form-group col-lg-12">
                                <label for="City" class="labelRequired">City </label>
                                <input type="text" class="form-control" placeholder="City" name="name" [(ngModel)]="editData.name" required #name="ngModel" [ngClass]="{'has-danger':cat?.submitted && name?.invalid }">
                                <div *ngIf="cat?.submitted && name?.invalid">
                                    <div [hidden]="!name.errors.required" class="formError"> *City Name is required </div>
                                </div>
                            </div>

                        </div>

                        </div>

                    </div>

                </mat-dialog-content>
            </div>

    </form>
</div>
